import React, { useContext, useState, useEffect, useRef, useCallback, useMemo } from "react";
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DatabaseContext } from "../../redux/DatabaseStore";
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, CalendarIcon, EditRowIcon, RefreshIcon } from "../svg/svgIcons";
import { deleteRequest, getRequest,postRequest } from '../../api/ApiController';
import {useReactToPrint} from "react-to-print";
import EightDreport from "../print/EightDreport";
import { DateTime } from "luxon";
import AuthContext from "../../components/AuthContext";
import moment from "moment";
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import UtilContext from "../../components/UtilContext";
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import { Chart } from 'primereact/chart';
import { Calendar } from '../../components/PrimeCalendar';
import { Skeleton } from 'primereact/skeleton';
import { addLocale } from 'primereact/api';
import { MachineStateDot } from '../../components/StatusIndicator';
import { getMntnGraphColors } from '../../utils/moduleSettings';
import {
    PREVIEW_PERIOD_OPTIONS as PERIOD_OPTIONS,
    PREVIEW_PERIOD_DEFAULT,
    defaultDateForPeriod,
    datePickerPropsForPeriod,
    toLocalDateString,
} from '../../utils/previewPeriodSelection';
import { LocaleContext } from '../../components/LocaleContext';
import {
    buildPreviewPeriodOptionLabels,
    registerPreviewCalendarLocale,
} from '../../utils/previewUiLocale';

const PREVIEW_PAGE = 'PreviewMaintenance';

function parseSavedPeriod(attrs) {
    if (!attrs?.preview_period || typeof attrs.preview_period?.timePeriod !== 'string') return null;
    if (!PERIOD_OPTIONS.includes(attrs.preview_period.timePeriod)) return null;
    const { timePeriod } = attrs.preview_period;
    const date = attrs.preview_period.date;
    if (timePeriod === 'Všetko') return { timePeriod, date: null };
    if (timePeriod === 'Vlastné' && Array.isArray(date) && date.length >= 2) {
        return { timePeriod, date: date.map((d) => (d != null ? new Date(d) : null)) };
    }
    if (date != null) {
        const d = new Date(date);
        if (!isNaN(d.getTime())) return { timePeriod, date: d };
    }
    return null;
}

function serializePeriod(timePeriod, date) {
    const payload = { timePeriod };
    if (date == null) payload.date = null;
    else if (Array.isArray(date)) payload.date = date.map((d) => (d instanceof Date ? toLocalDateString(d) : d));
    else payload.date = date instanceof Date ? toLocalDateString(date) : date;
    return payload;
}

function getDateRange(timePeriod, date) {
    if (!date || timePeriod === 'Všetko') return null;
    if (Array.isArray(date) && date.length >= 2) return { dateFrom: new Date(date[0]), dateTo: new Date(date[1]) };
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    let dateFrom, dateTo;
    if (timePeriod === "Za deň") {
        dateFrom = new Date(d); dateFrom.setHours(0, 0, 0, 0);
        dateTo = new Date(d); dateTo.setHours(23, 59, 59, 999);
    } else if (timePeriod === 'Za mesiac') {
        dateFrom = new Date(d.getFullYear(), d.getMonth(), 1);
        dateTo = new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
    } else if (timePeriod === 'Za rok') {
        dateFrom = new Date(d.getFullYear(), 0, 1);
        dateTo = new Date(d.getFullYear(), 11, 31, 23, 59, 59, 999);
    } else return null;
    return { dateFrom, dateTo };
}

export default function PreviewMaintenance(){

    const [state, dispatch] = useContext(DatabaseContext);
    const { user } = useContext(AuthContext);
    const { setUserMaskFilter } = useContext(UtilContext);
    const { t, locale } = useContext(LocaleContext);
    const periodOptionLabels = useMemo(() => buildPreviewPeriodOptionLabels(t), [t]);
    const [calendarLocale, setCalendarLocale] = useState(() => registerPreviewCalendarLocale(addLocale, locale, t));

    useEffect(() => {
        setCalendarLocale(registerPreviewCalendarLocale(addLocale, locale, t));
    }, [locale, t]);

    const module_settings = state?.module_settings || [];
    const maintenanceChartColors = useMemo(() => getMntnGraphColors(module_settings), [module_settings]);
    const maintenanceChartColors2 = useMemo(() => {
        const colors = getMntnGraphColors(module_settings);
        return [colors[3], colors[0]]; // OK, Po expirácii
    }, [module_settings]);
    const certPeriodColors = useMemo(() => {
        const colors = getMntnGraphColors(module_settings);
        return [colors[3], colors[0]]; // OK, Po expirácii
    }, [module_settings]);
    const checklistPeriodColors = ['#2563eb', '#15803d', '#b91c1c']; // otvorené, OK, NOK
    const [loading, setLoading] = useState(true);
    const [machineMaintenanceData, setMachineMaintenanceData] = useState({
        labels: [t('PreviewMaintenance.Text.Po_expiracii'), t('Common.DaysToExp15'), t('Common.DaysToExp30'), t('Common.Status.OK')],
        datasets: [{ data: [0, 0, 0, 0], backgroundColor: [], hoverBackgroundColor: [] }]
    });
    const [companyMaintenanceData, setCompanyMaintenanceData] = useState({
        labels: [t('PreviewMaintenance.Text.Po_expiracii'), t('Common.DaysToExp15'), t('Common.DaysToExp30'), t('Common.Status.OK')],
        datasets: [{ data: [0, 0, 0, 0], backgroundColor: [], hoverBackgroundColor: [] }]
    });
    const [machineChecklistData, setMachineChecklistData] = useState({
        labels: [t('PreviewMaintenance.Text.Nevytvorene'), t('PreviewMaintenance.Text.Rozpracovane'), t('PreviewMaintenance.Text.NOK_vytvorene'), t('PreviewMaintenance.Text.Chyba_vyjadrenie')],
        datasets: [{ data: [0, 0, 0, 0], backgroundColor: ['#2563eb', '#eab308', '#15803d', '#b91c1c'], hoverBackgroundColor: ['#2563eb', '#eab308', '#15803d', '#b91c1c'] }]
    });
    const [machineStatesChartData, setMachineStatesChartData] = useState({
        labels: [t('PreviewMaintenance.StateInFault'), t('Common.WorkingLimited'), t('PreviewMaintenance.StateFunctional')],
        datasets: [{ data: [0, 0, 0], backgroundColor: ['#b91c1c', '#ca8a04', '#15803d'], hoverBackgroundColor: ['#b91c1c', '#ca8a04', '#15803d'] }]
    });
    const [inFaultTasks, setInFaultTasks] = useState([]);
    const [workingLimitedTasks, setWorkingLimitedTasks] = useState([]);
    const [timePeriod, setTimePeriod] = useState(PREVIEW_PERIOD_DEFAULT);
    const [date, setDate] = useState(null);
    const [dateProps, setDateProps] = useState({ hidden: true });
    const [periodStats, setPeriodStats] = useState(null);
    const appliedSavedRef = useRef(false);
    const statsRequestIdRef = useRef(0);

    // Pri zvolenom období meníme len hodnoty v grafoch (žiadne nové sekcie). Farby z Všeobecných nastavení údržby (semafor).
    const displayMachineData = useMemo(() => {
        if (periodStats) {
            return {
                labels: [t('Maintenance.TasksOnTime'), t('PreviewMaintenance.Text.Ukony_urobene_po_termine')],
                datasets: [{
                    data: [periodStats.done_on_time ?? 0, periodStats.done_late ?? 0],
                    backgroundColor: maintenanceChartColors2,
                    hoverBackgroundColor: maintenanceChartColors2,
                }],
            };
        }
        return {
            ...machineMaintenanceData,
            labels: [t('PreviewMaintenance.Text.Po_expiracii'), t('Common.DaysToExp15'), t('Common.DaysToExp30'), t('Common.Status.OK')],
            datasets: [{
                ...machineMaintenanceData.datasets[0],
                backgroundColor: maintenanceChartColors,
                hoverBackgroundColor: maintenanceChartColors,
            }],
        };
    }, [periodStats, machineMaintenanceData, maintenanceChartColors, maintenanceChartColors2, t]);

    const displayStatesData = useMemo(() => {
        if (periodStats) {
            return {
                labels: [t('PreviewMaintenance.Text.Pocet_pokazenych_strojov'), t('Common.WorkingLimited'), t('PreviewMaintenance.Text.Pocet_strojov_bez_poruchy')],
                datasets: [{
                    data: [
                        periodStats.broken_machines_count ?? 0,
                        periodStats.pso_machines_count ?? 0,
                        periodStats.machines_without_fault_count ?? 0,
                    ],
                    backgroundColor: ['#b91c1c', '#ca8a04', '#15803d'],
                    hoverBackgroundColor: ['#b91c1c', '#ca8a04', '#15803d'],
                }],
            };
        }
        return {
            ...machineStatesChartData,
            labels: [t('PreviewMaintenance.StateInFault'), t('Common.WorkingLimited'), t('PreviewMaintenance.StateFunctional')],
        };
    }, [periodStats, machineStatesChartData, t]);

    const displayCompanyData = useMemo(() => {
        if (periodStats) {
            return {
                labels: [t('Maintenance.CertsUploadedOnTime'), t('PreviewMaintenance.Text.Certifikaty_nahrate_po_termine')],
                datasets: [{
                    data: [periodStats.certs_on_time ?? 0, periodStats.certs_late ?? 0],
                    backgroundColor: certPeriodColors,
                    hoverBackgroundColor: certPeriodColors,
                }],
            };
        }
        return {
            ...companyMaintenanceData,
            labels: [t('PreviewMaintenance.Text.Po_expiracii'), t('Common.DaysToExp15'), t('Common.DaysToExp30'), t('Common.Status.OK')],
            datasets: [{
                ...companyMaintenanceData.datasets[0],
                backgroundColor: maintenanceChartColors,
                hoverBackgroundColor: maintenanceChartColors,
            }],
        };
    }, [periodStats, companyMaintenanceData, maintenanceChartColors, certPeriodColors, t]);

    const displayChecklistData = useMemo(() => {
        if (periodStats) {
            return {
                labels: [t('Status.OpenPlural'), t('PreviewMaintenance.OkChecklists'), t('PreviewMaintenance.NokChecklists')],
                datasets: [{
                    data: [
                        periodStats.open_checklists ?? 0,
                        periodStats.ok_checklists ?? 0,
                        periodStats.nok_checklists ?? 0,
                    ],
                    backgroundColor: checklistPeriodColors,
                    hoverBackgroundColor: checklistPeriodColors,
                }],
            };
        }
        return {
            ...machineChecklistData,
            labels: [t('PreviewMaintenance.Text.Nevytvorene'), t('PreviewMaintenance.Text.Rozpracovane'), t('PreviewMaintenance.Text.NOK_vytvorene'), t('PreviewMaintenance.Text.Chyba_vyjadrenie')],
        };
    }, [periodStats, machineChecklistData, t]);

    const buildStatsParams = useCallback((timePeriodVal, dateVal) => {
        if (!timePeriodVal || timePeriodVal === 'Všetko' || !dateVal) return {};
        if (timePeriodVal === 'Vlastné' && Array.isArray(dateVal) && dateVal.length >= 2) {
            const d0 = dateVal[0] instanceof Date ? dateVal[0] : new Date(dateVal[0]);
            const d1 = dateVal[1] instanceof Date ? dateVal[1] : new Date(dateVal[1]);
            return { time_period: timePeriodVal, date_from: toLocalDateString(d0), date_to: toLocalDateString(d1) };
        }
        const d = Array.isArray(dateVal) ? dateVal[0] : dateVal;
        if (!d || !(d instanceof Date)) return {};
        return { time_period: timePeriodVal, date: toLocalDateString(d) };
    }, []);

    const loadPreviewStats = useCallback((timePeriodVal, dateVal) => {
        const requestId = ++statsRequestIdRef.current;
        setLoading(true);
        const params = buildStatsParams(timePeriodVal ?? timePeriod, dateVal ?? date);
        const query = new URLSearchParams(params).toString();
        const url = query ? `/api/maintenance_preview_stats?${query}` : '/api/maintenance_preview_stats';
        getRequest(url).then((resp) => {
            if (requestId !== statsRequestIdRef.current) return;
            const d = resp?.data;
            if (!d) return;
            setMachineMaintenanceData(prev => ({
                ...prev,
                datasets: [{ ...prev.datasets[0], data: d.machine ?? [0, 0, 0, 0] }]
            }));
            setCompanyMaintenanceData(prev => ({
                ...prev,
                datasets: [{ ...prev.datasets[0], data: d.company ?? [0, 0, 0, 0] }]
            }));
            setMachineChecklistData(prev => ({
                ...prev,
                datasets: [{ ...prev.datasets[0], data: [d.checklist?.nevytvorene ?? 0, d.checklist?.rozpracovane ?? 0, d.checklist?.nok_vytvorene ?? 0, d.checklist?.chyba_vyjadrenie ?? 0] }]
            }));
            setMachineStatesChartData({
                labels: [t('PreviewMaintenance.StateInFault'), t('Common.WorkingLimited'), t('PreviewMaintenance.StateFunctional')],
                datasets: [{ data: d.states ?? [0, 0, 0], backgroundColor: ['#b91c1c', '#ca8a04', '#15803d'], hoverBackgroundColor: ['#b91c1c', '#ca8a04', '#15803d'] }]
            });
            setInFaultTasks(d.critical?.in_fault ?? []);
            setWorkingLimitedTasks(d.critical?.working_limited ?? []);
            setPeriodStats(d.period ?? null);
        }).catch(() => {
            if (requestId !== statsRequestIdRef.current) return;
        }).finally(() => {
            if (requestId === statsRequestIdRef.current) setLoading(false);
        });
    }, [timePeriod, date, buildStatsParams, t]);

    useEffect(() => {
        if (appliedSavedRef.current) return;
        if (!state.user_mask_filters?.length) return;
        appliedSavedRef.current = true;
        const mask = state.user_mask_filters.find((m) => m.page === PREVIEW_PAGE);
        const attrs = mask?.attributes;
        const parsed = typeof attrs === 'string' ? (() => { try { return parseSavedPeriod(JSON.parse(attrs)); } catch { return null; } })() : parseSavedPeriod(attrs);
        if (parsed) {
            setTimePeriod(parsed.timePeriod);
            setDate(parsed.date ?? defaultDateForPeriod(parsed.timePeriod));
            setDateProps(datePickerPropsForPeriod(parsed.timePeriod));
        }
    }, [state.user_mask_filters]);

    // Refetch when user changes alebo keď sa zmení obdobie/dátum
    useEffect(() => {
        if (!user) {
            setLoading(true);
            setMachineMaintenanceData(prev => ({ ...prev, datasets: [{ ...prev.datasets[0], data: [0, 0, 0, 0] }] }));
            setCompanyMaintenanceData(prev => ({ ...prev, datasets: [{ ...prev.datasets[0], data: [0, 0, 0, 0] }] }));
            setMachineChecklistData(prev => ({ ...prev, datasets: [{ ...prev.datasets[0], data: [0, 0, 0, 0] }] }));
            setMachineStatesChartData(prev => ({ ...prev, datasets: [{ ...prev.datasets[0], data: [0, 0, 0] }] }));
            setInFaultTasks([]);
            setWorkingLimitedTasks([]);
            setPeriodStats(null);
            setLoading(false);
            return;
        }
        loadPreviewStats();
    }, [loadPreviewStats, user?.id]);

    const [legendHidden, setLegendHidden] = useState({ machine: [], states: [], company: [], checklist: [] });
    const originalDataRef = useRef({ machine: [], states: [], company: [], checklist: [] });
    const originalTotal = (key, fallbackArr) => {
        // primárne používaj aktuálny dataset (fallbackArr),
        // aby celkový počet vždy sedel s tým, čo je v grafe
        const base = (fallbackArr && fallbackArr.length) ? fallbackArr : originalDataRef.current[key];
        const src = base ?? [];
        return src.reduce((a, b) => a + (Number(b) || 0), 0);
    };
    const machineChartRef = useRef(null);
    const stateChartRef = useRef(null);
    const companyChartRef = useRef(null);
    const checklistChartRef = useRef(null);

    const toggleLegendItem = (chartKey, index, chartRef) => () => {
        const ch = chartRef?.current?.getChart?.();
        if (!ch) return;
        const originals = originalDataRef.current[chartKey];
        if (!Array.isArray(originals)) return;
        const currentlyHidden = legendHidden[chartKey]?.[index];
        const nextHidden = !currentlyHidden;
        const hiddenArr = legendHidden[chartKey] ?? [];
        const newData = originals.map((val, i) => {
            const isHidden = i === index ? nextHidden : hiddenArr[i];
            return isHidden ? 0 : (Number(val) || 0);
        });
        const ds = ch.data.datasets[0];
        ds.data = [...newData];
        const meta = ch.getDatasetMeta?.(0);
        if (meta && Array.isArray(meta._parsed)) newData.forEach((v, i) => { meta._parsed[i] = v; });
        ch.update();
        setLegendHidden((prev) => {
            const arr = prev[chartKey] ?? [];
            const next = [...arr];
            next[index] = nextHidden;
            return { ...prev, [chartKey]: next };
        });
    };

    useEffect(() => {
        const d = (src) => (src?.datasets?.[0]?.data ? [...src.datasets[0].data] : []);
        originalDataRef.current = {
            machine: d(displayMachineData),
            states: d(displayStatesData),
            company: d(displayCompanyData),
            checklist: d(displayChecklistData),
        };
    }, [displayMachineData, displayStatesData, displayCompanyData, displayChecklistData]);

    const periodStatsRef = useRef(null);
    const rangeRef = useRef(null);
    const range = useMemo(() => getDateRange(timePeriod, date), [timePeriod, date]);
    periodStatsRef.current = periodStats;
    rangeRef.current = range;

    const [employeeTrainingOptions] = useState({
        plugins: { legend: { display: false } },
        onClick: function (evt, item) {
            if (!item?.length) return;
            if (periodStatsRef.current && rangeRef.current) {
                const seg = item[0].index === 0 ? 'on_time' : 'late';
                const r = rangeRef.current;
                const dateFrom = toLocalDateString(r.dateFrom);
                const dateTo = toLocalDateString(r.dateTo);
                dispatch({ type: 'create_new_tab', name: t('TrainingCompanyCertStateList'), translationKey: 'TrainingCompanyCertStateList', legacyLabel: t('TrainingCompanyCertStateList'), page: 'MaintenanceStateList', props: { preview_period: { dateFrom, dateTo }, preview_segment: seg }, mask: 'mntn023' });
                return;
            }
            if (item[0].index === 0) dispatch({ type: 'create_new_tab', name: t('TrainingCompanyCertStateList'), translationKey: 'TrainingCompanyCertStateList', legacyLabel: t('TrainingCompanyCertStateList'), page: 'MaintenanceStateList', props: { preview: 'after' }, mask: 'mntn023' });
            else if (item[0].index === 1) dispatch({ type: 'create_new_tab', name: t('TrainingCompanyCertStateList'), translationKey: 'TrainingCompanyCertStateList', legacyLabel: t('TrainingCompanyCertStateList'), page: 'MaintenanceStateList', props: { preview: '15' }, mask: 'mntn023' });
            else if (item[0].index === 2) dispatch({ type: 'create_new_tab', name: t('TrainingCompanyCertStateList'), translationKey: 'TrainingCompanyCertStateList', legacyLabel: t('TrainingCompanyCertStateList'), page: 'MaintenanceStateList', props: { preview: '30' }, mask: 'mntn023' });
            else if (item[0].index === 3) dispatch({ type: 'create_new_tab', name: t('TrainingCompanyCertStateList'), translationKey: 'TrainingCompanyCertStateList', legacyLabel: t('TrainingCompanyCertStateList'), page: 'MaintenanceStateList', props: { preview: 'others' }, mask: 'mntn023' });
        }
    });

    const machineStateChartOptions = useMemo(() => ({
        plugins: { legend: { display: false } },
        onClick(evt, item) {
            if (!item?.length) return;
            const map = { 0: 'in_fault', 1: 'working_limited', 2: 'functional' };
            const machineState = map[item[0].index];
            dispatch({ type: 'create_new_tab', name: t('Maintenance.MachineOutages'), translationKey: 'Maintenance.MachineOutages', legacyLabel: t('Maintenance.MachineOutages'), page: 'MaintenanceMachineStateList', props: { preview: machineState }, mask: 'mntn037' });
        }
    }), [dispatch]);

    const [companyTrainingOptions] = useState({
        plugins: { legend: { display: false } },
        onClick: function (evt, item) {
            if (!item?.length) return;
            if (periodStatsRef.current && rangeRef.current) {
                const seg = item[0].index === 0 ? 'on_time' : 'late';
                const r = rangeRef.current;
                const dateFrom = toLocalDateString(r.dateFrom);
                const dateTo = toLocalDateString(r.dateTo);
                dispatch({ type: 'create_new_tab', name: t('Maintenance.ServiceCompanyCertificates'), translationKey: 'Maintenance.ServiceCompanyCertificates', legacyLabel: t('Maintenance.ServiceCompanyCertificates'), page: 'MaintenanceCompanyCertStateList', props: { preview_period: { dateFrom, dateTo }, preview_segment: seg }, mask: 'mntn010' });
                return;
            }
            if (item[0].index === 0) dispatch({ type: 'create_new_tab', name: t('Maintenance.ServiceCompanyCertificates'), translationKey: 'Maintenance.ServiceCompanyCertificates', legacyLabel: t('Maintenance.ServiceCompanyCertificates'), page: 'MaintenanceCompanyCertStateList', props: { preview: 'after' }, mask: 'mntn010' });
            else if (item[0].index === 1) dispatch({ type: 'create_new_tab', name: t('Maintenance.ServiceCompanyCertificates'), translationKey: 'Maintenance.ServiceCompanyCertificates', legacyLabel: t('Maintenance.ServiceCompanyCertificates'), page: 'MaintenanceCompanyCertStateList', props: { preview: '15' }, mask: 'mntn010' });
            else if (item[0].index === 2) dispatch({ type: 'create_new_tab', name: t('Maintenance.ServiceCompanyCertificates'), translationKey: 'Maintenance.ServiceCompanyCertificates', legacyLabel: t('Maintenance.ServiceCompanyCertificates'), page: 'MaintenanceCompanyCertStateList', props: { preview: '30' }, mask: 'mntn010' });
            else if (item[0].index === 3) dispatch({ type: 'create_new_tab', name: t('Maintenance.ServiceCompanyCertificates'), translationKey: 'Maintenance.ServiceCompanyCertificates', legacyLabel: t('Maintenance.ServiceCompanyCertificates'), page: 'MaintenanceCompanyCertStateList', props: { preview: 'others' }, mask: 'mntn010' });
        }
    });

    const [machineChecklistOptions] = useState({
        plugins: { legend: { display: false } },
        onClick: function (evt, item) {
            if(!item?.length) return;
            const previewMap = ['nevytvorene', 'rozpracovane', 'nok_vytvorene', 'chyba_vyjadrenie'];
            const preview = previewMap[item[0].index];
            if (preview) {
                dispatch({ type: 'create_new_tab', name: t('PreviewMaintenance.Text.Checklisty_strojov_podla_stavu'), translationKey: 'PreviewMaintenance.Text.Checklisty_strojov_podla_stavu', legacyLabel: t('PreviewMaintenance.Text.Checklisty_strojov_podla_stavu'), page: 'MaintenanceCheckStateList', props: { preview }, mask: 'mntn029' });
            }
        }
    });

    const plugin = {
        id: 'emptyDoughnut',
        afterDraw(chart) {
            const data = chart.data?.datasets?.[0]?.data ?? [];
            const count = data.reduce((a, b) => a + (b ?? 0), 0);
            if (count < 1) {
                const ctx = chart.ctx;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.font = '20px Arial';
                ctx.fillStyle = '#9ca3af';
                ctx.fillText(t('Common.NoRecords'), chart.width / 2, chart.height / 2);
            }
        },
    };

    const legendEl = (labels, colors, chartKey, chartRef, hiddenArr = []) => (
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mt-2 text-sm text-gray-700">
            {labels?.map((label, i) => (
                chartRef != null ? (
                    <button key={i} type="button" onClick={toggleLegendItem(chartKey, i, chartRef)} className="inline-flex items-center gap-1.5 cursor-pointer bg-transparent border-0 p-0 text-left hover:opacity-80" style={{ textDecoration: hiddenArr[i] ? 'line-through' : undefined, opacity: hiddenArr[i] ? 0.5 : 1 }}>
                        <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: colors?.[i] ?? '#6b7280' }} />
                        {label}
                    </button>
                ) : (
                    <span key={i} className="inline-flex items-center gap-1.5">
                        <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: colors?.[i] ?? '#6b7280' }} />
                        {label}
                    </span>
                )
            ))}
        </div>
    );

    const formatSince = (since) => {
        if (!since) return '—';
        const dt = DateTime.fromISO(since);
        return dt.isValid ? dt.setLocale('sk').toLocaleString(DateTime.DATETIME_SHORT) : since;
    };

    const openTicket = (task) => {
        dispatch({ type: 'create_new_tab', name: t('Util.Tab.ServiceTaskDetail'), translationKey: 'Util.Tab.ServiceTaskDetail', legacyLabel: t('Util.Tab.ServiceTaskDetail'), page: 'ServiceTaskDetail', props: { task }, mask: 'intr004' });
    };

    function changeTimePeriod(time_period) {
        setTimePeriod(time_period);
        setDate(defaultDateForPeriod(time_period));
        setDateProps(datePickerPropsForPeriod(time_period));
        setPeriodStats(null);
        setLoading(true);
    }

    function showResult(dateVal) {
        setLoading(true);
        setDate(dateVal);
    }

    const savePeriodToDb = () => {
        setUserMaskFilter(PREVIEW_PAGE, 'set_attributes', null, null, { preview_period: serializePeriod(timePeriod, date) });
    };

    const handleRefresh = () => {
        setLoading(true);
        loadPreviewStats();
    };

    return (
        <div className="h-[calc(100vh-137px)] overflow-y-auto">
        <div className="lg:grid grid-cols-3 gap-1">
            <div></div>
            <div>
                <div className="flex items-center gap-3 mt-4">
                    <label htmlFor="time_period" className="text-xl font-semibold text-gray-800 shrink-0">{t('Common.PeriodLabel')}</label>
                    <select
                        name="time_period"
                        id="time_period"
                        value={timePeriod}
                        onChange={(e) => changeTimePeriod(e.target.value)}
                        className="bg-white flex-1 min-w-0 px-4 py-2 text-gray-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    >
                        <option value="Všetko">{periodOptionLabels['Všetko']}</option>
                        <option value="Za deň">{periodOptionLabels['Za deň']}</option>
                        <option value="Za mesiac">{periodOptionLabels['Za mesiac']}</option>
                        <option value="Za rok">{periodOptionLabels['Za rok']}</option>
                        <option value="Vlastné">{periodOptionLabels['Vlastné']}</option>
                    </select>
                    <button
                        type="button"
                        onClick={handleRefresh}
                        title={t('Common.RefreshData')}
                        className="flex items-center justify-center w-10 h-10 shrink-0 rounded-md border border-gray-300 bg-gray-600 hover:bg-gray-700 text-white transition-colors"
                    >
                        <RefreshIcon />
                    </button>
                    <button
                        type="button"
                        onClick={savePeriodToDb}
                        title={t('ServiceTaskPreview.SavePeriodHint')}
                        className="shrink-0 px-3 py-2 text-sm font-medium rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring focus:ring-gray-200"
                    >
                        {t('Common.SaveMask')}
                    </button>
                </div>
            </div>
            <div></div>
            <div></div>
            <div className="flex-auto">
                <Calendar
                    id="buttondisplay"
                    style={{ border: '1px solid #e5e7eb', transition: 'background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s', borderRadius: '6px' }}
                    value={date}
                    onChange={(e) => showResult(e.target.value)}
                    showIcon
                    className="w-full"
                    visible={true}
                    locale={calendarLocale}
                    {...dateProps}
                    hideOnRangeSelection
                />
            </div>
            <div></div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 p-4 items-start">
          <div className="bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 rounded-xl shadow-md p-4 min-w-0">
            <h2 className="text-xl font-semibold mb-4">{t('PreviewMaintenance.Critical')}</h2>
            {loading ? (
              <div className="space-y-3 mt-3">
                <Skeleton width="100%" height="2rem" />
                <Skeleton width="100%" height="12rem" />
                <Skeleton width="100%" height="2rem" />
                <Skeleton width="100%" height="10rem" />
              </div>
            ) : (
            <>
            <div className="flex items-center justify-between mt-3 mb-2">
              <h3 className="text-base font-medium text-gray-800">{t('PreviewMaintenance.CriticalInFault')}</h3>
              <span className="text-base font-medium text-gray-600">{t('PreviewMaintenance.CriticalSince')}</span>
            </div>
            <ul className={`list-none space-y-2 mb-4 ${(inFaultTasks.length + workingLimitedTasks.length) > 8 ? 'columns-2 gap-x-6' : ''}`}>
              {inFaultTasks.length === 0 ? (
                <li className="text-gray-500 text-sm">{t('PreviewMaintenance.CriticalNone')}</li>
              ) : (
                inFaultTasks.map((task) => (
                  <li key={task.id} className="flex items-center gap-2 flex-nowrap break-inside-avoid mb-2 min-w-0">
                    <button type="button" onClick={() => openTicket(task)} className="inline-flex items-center gap-2 p-0 border-0 bg-transparent cursor-pointer hover:opacity-80 text-left shrink-0">
                      <MachineStateDot task={task} />
                    </button>
                    <span className="font-medium truncate min-w-0" title={task.machine?.name ?? '—'}>{task.machine?.name ?? '—'}</span>
                    <span className="text-gray-600 shrink-0">{task.defined_id ?? task.id}</span>
                    <span className="text-gray-500 text-sm shrink-0 whitespace-nowrap ml-auto">{formatSince(task.since)}</span>
                  </li>
                ))
              )}
            </ul>
            <div className="flex items-center justify-between mt-3 mb-2">
              <h3 className="text-base font-medium text-gray-800">{t('PreviewMaintenance.CriticalLimited')}</h3>
              <span className="text-base font-medium text-gray-600">{t('PreviewMaintenance.CriticalSince')}</span>
            </div>
            <ul className={`list-none space-y-2 ${(inFaultTasks.length + workingLimitedTasks.length) > 8 ? 'columns-2 gap-x-6' : ''}`}>
              {workingLimitedTasks.length === 0 ? (
                <li className="text-gray-500 text-sm">{t('PreviewMaintenance.CriticalNone')}</li>
              ) : (
                workingLimitedTasks.map((task) => (
                  <li key={task.id} className="flex items-center gap-2 flex-nowrap break-inside-avoid mb-2 min-w-0">
                    <button type="button" onClick={() => openTicket(task)} className="inline-flex items-center gap-2 p-0 border-0 bg-transparent cursor-pointer hover:opacity-80 text-left shrink-0">
                      <MachineStateDot task={task} />
                    </button>
                    <span className="font-medium truncate min-w-0" title={task.machine?.name ?? '—'}>{task.machine?.name ?? '—'}</span>
                    <span className="text-gray-600 shrink-0">{task.defined_id ?? task.id}</span>
                    <span className="text-gray-500 text-sm shrink-0 whitespace-nowrap ml-auto">{formatSince(task.since)}</span>
                  </li>
                ))
              )}
            </ul>
            </>
            )}
          </div>
          <div className="bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 rounded-xl shadow-md p-4">
            <h2 className="text-center text-xl font-semibold mb-4">{t('PreviewMaintenance.Planned')}</h2>
            <div className="w-full max-w-[420px] h-[420px] mx-auto flex items-center justify-center">
              {loading ? <Skeleton shape="circle" size="320px" className="flex-shrink-0" /> : <Chart ref={machineChartRef} type="doughnut" data={displayMachineData} options={employeeTrainingOptions} className="w-full h-full" plugins={[plugin]} />}
            </div>
            {!loading && legendEl(displayMachineData.labels, displayMachineData.datasets?.[0]?.backgroundColor, 'machine', machineChartRef, legendHidden.machine)}
            <div className="text-center font-semibold mt-4">{loading ? <Skeleton width="8rem" height="1.5rem" className="mx-auto" /> : t('Common.TotalCount', { count: originalTotal('machine', displayMachineData?.datasets?.[0]?.data) })}</div>
          </div>
          <div className="bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 rounded-xl shadow-md p-4">
            <h2 className="text-center text-xl font-semibold mb-4">{t('PreviewMaintenance.MachineOutages')}</h2>
            <div className="w-full max-w-[420px] h-[420px] mx-auto flex items-center justify-center">
              {loading ? <Skeleton shape="circle" size="320px" className="flex-shrink-0" /> : <Chart ref={stateChartRef} type="doughnut" data={displayStatesData} options={machineStateChartOptions} className="w-full h-full" plugins={[plugin]} />}
            </div>
            {!loading && legendEl(displayStatesData.labels, displayStatesData.datasets?.[0]?.backgroundColor, 'states', stateChartRef, legendHidden.states)}
            <div className="text-center font-semibold mt-4">{loading ? <Skeleton width="8rem" height="1.5rem" className="mx-auto" /> : t('Common.TotalCount', { count: originalTotal('states', displayStatesData?.datasets?.[0]?.data) })}</div>
          </div>
          <div className="bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 rounded-xl shadow-md p-4">
            <h2 className="text-center text-xl font-semibold mb-4">{t('PreviewMaintenance.ServiceCompanyCertificates')}</h2>
            <div className="w-full max-w-[420px] h-[420px] mx-auto flex items-center justify-center">
              {loading ? <Skeleton shape="circle" size="320px" className="flex-shrink-0" /> : <Chart ref={companyChartRef} type="doughnut" data={displayCompanyData} options={companyTrainingOptions} className="w-full h-full" plugins={[plugin]} />}
            </div>
            {!loading && legendEl(displayCompanyData.labels, displayCompanyData.datasets?.[0]?.backgroundColor, 'company', companyChartRef, legendHidden.company)}
            <div className="text-center font-semibold mt-4">{loading ? <Skeleton width="8rem" height="1.5rem" className="mx-auto" /> : t('Common.TotalCount', { count: originalTotal('company', displayCompanyData?.datasets?.[0]?.data) })}</div>
          </div>
          <div className="bg-gradient-to-r from-gray-50 via-gray-100 to-gray-200 rounded-xl shadow-md p-4">
            <h2 className="text-center text-xl font-semibold mb-4">{t('PreviewMaintenance.OpenMachineChecklists')}</h2>
            <div className="w-full max-w-[420px] h-[420px] mx-auto flex items-center justify-center">
              {loading ? <Skeleton shape="circle" size="320px" className="flex-shrink-0" /> : <Chart ref={checklistChartRef} type="doughnut" data={displayChecklistData} options={machineChecklistOptions} className="w-full h-full" plugins={[plugin]} />}
            </div>
            {!loading && legendEl(displayChecklistData.labels, displayChecklistData.datasets?.[0]?.backgroundColor, 'checklist', checklistChartRef, legendHidden.checklist)}
            <div className="text-center font-semibold mt-4">{loading ? <Skeleton width="8rem" height="1.5rem" className="mx-auto" /> : t('Common.TotalCount', { count: originalTotal('checklist', displayChecklistData?.datasets?.[0]?.data) })}</div>
          </div>
        </div>
</div>
    );
}
